<template>
    <h1 class="mt-5">{{$t('servicemessage.mess')}} </h1>
</template>

<script>
// 使用i18对象
import { useI18n } from 'vue-i18n'

export default {
    setup() {
        const {t}=useI18n

        return {t}
    },
}
</script>